import { GetWorkspaceCoachees, WorkspaceId } from "@/sdk";

const COACHEES_LIST_QUERY_ID = 'coachees_list_query';

export type CoacheesListQueryStorage = {
  workspaceId: WorkspaceId;
  query: GetWorkspaceCoachees.Query
}

export function loadCoacheesListQuery(): CoacheesListQueryStorage | null {
  const content = localStorage.getItem(COACHEES_LIST_QUERY_ID);
  if (!content) return null;
  try {
    return JSON.parse(content);
  } catch (error) {
    localStorage.removeItem(COACHEES_LIST_QUERY_ID);
    return null;
  }
}

export function saveCoacheesListQuery(query: CoacheesListQueryStorage): void {
  const data = JSON.stringify(query);
  localStorage.setItem(COACHEES_LIST_QUERY_ID, data);
}

export function resetCoacheesListQuery(): void {
  localStorage.removeItem(COACHEES_LIST_QUERY_ID);
}
